import {
  Component,
  Input,
  ViewChild,
  type ElementRef,
  type OnInit,
} from '@angular/core';
import { ComposableCardConfig } from '@legacy/common-ui-common-renderings';
import { InnogyComponentRendering } from '@core/jss-models';
import { getFieldValue } from '@core/jss-utils';
import { Review } from '@integration/reviews-api-models';

@Component({
  selector: 'wl-review[review]',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.essent.scss', './review.component.ed.scss'],
})
export class ReviewComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() review!: Review;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showScoreBorder = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() cardConfig?: ComposableCardConfig = {
    backgroundColorClass: 'bg-white',
    borderClass: '',
    borderRoundingClass: 'rounded',
    stretchVertical: false,
    shadow: false,
  };
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  @ViewChild('reviewText', { static: true }) reviewText!: ElementRef;

  readMoreButtonTitle?: string;
  readLessButtonTitle?: string;
  reviewTextExpanded = false;

  get reviewTextTruncated() {
    const reviewTextElement = this.reviewText.nativeElement;
    return reviewTextElement.scrollHeight > reviewTextElement.clientHeight;
  }

  get showBorder(): boolean {
    return (
      this.showScoreBorder ||
      this.cardConfig?.backgroundColorClass === 'bg-brand' ||
      this.cardConfig?.backgroundColorClass === 'bg-brand-gradient'
    );
  }

  onExpand(): void {
    this.reviewTextExpanded = !this.reviewTextExpanded;
  }

  ngOnInit(): void {
    this.readMoreButtonTitle = getFieldValue(
      this.rendering,
      'ReadMoreButtonTitle',
      'Meer informatie'
    );
    this.readLessButtonTitle = getFieldValue(
      this.rendering,
      'ReadLessButtonTitle',
      'Minder informatie'
    );
  }
}
